export default "__VITE_ASSET__50jU7lmB__"